<template>
  <b-modal
    title="Novo endereço adicional"
    no-close-on-backdrop
    size="lg"
    hide-footer
    centered
    header-bg-variant="orange"
    header-text-variant="light"
    v-model="open"
    :busy="loading"
  >
    <b-row>
     <b-col cols="12" class="mt-3">
      <label>Nome: </label>
      <b-input v-model="dataAddress.name" class="mt-1" />
     </b-col>

     <b-col cols="12" lg="3" class="mt-3">
      <label>Cep: </label>
      <b-input 
        v-model="dataAddress.cep" 
        class="mt-1" 
        v-mask="'#####-###'"
        @change="consultCep()"
      />
     </b-col>

     <b-col cols="12" lg="7" class="mt-3">
      <label>Endereço: </label>
      <b-input v-model="dataAddress.address" class="mt-1" />
     </b-col>

     <b-col cols="12" lg="2" class="mt-3">
      <label>Número: </label>
      <b-input v-model="dataAddress.number" class="mt-1" />
     </b-col>

     <b-col cols="12" lg="6" class="mt-3">
      <label>Complemento: </label>
      <b-input  v-model="dataAddress.complement" class="mt-1" />
     </b-col>

     <b-col cols="12" lg="6" class="mt-3">
      <label>Bairro: </label>
      <b-input 
        v-model="dataAddress.district" 
        class="mt-1" 
      />
     </b-col>

     <b-col cols="12" lg="8" class="mt-3">
      <label>Cidade: </label>
      <b-input v-model="dataAddress.city" disabled class="mt-1" />
     </b-col>

     <b-col cols="12" lg="4" class="mt-3">
      <label>Estado: </label>
      <b-input v-model="dataAddress.state" disabled class="mt-1" />
     </b-col>

     <b-col cols="12" class="mt-4 mb-2">
      <b-button
        v-if="dataAddress.id"
        variant="success"
        block
        @click="update()"
      >
        Atualizar
      </b-button>
      <b-button
        v-else
        variant="success"
        block
        @click="save()"
      >
        Cadastrar
      </b-button>
     </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import makeToast from '@/mixins/makeToast';
import { mapActions } from 'vuex';
import UserTypes from '@/enums/UserTypes';

export default {
name: 'AddressAdditional',
mixins: [makeToast],
emits: ['getAddress'],

data() {
  return {
    loading: false,
    open: false,
    isUpdate: false,
    dataAddress: {
      name: "",
      address: "",
      number: "",
      complement: "",
      district: "",
      city: "",
      state: "",
      usuario_id: "",
      cep: "",
      id: ""
    },
  };
},

methods: {
  ...mapActions('shopkeeper', [
    'updateAddressAdditional', 
    'createAddressAdditional',
    'createAddressAdditionalByClerk',
    'updateAddressAdditionalByClerk'
  ]),

  toggleOpen({data = [], idUser = ""}) {
    this.open = !this.open;
    this.dataAddress.name = data.name ? data.name : "";
    this.dataAddress.address = data.address ? data.address : "";
    this.dataAddress.number = data.number ? data.number : "";
    this.dataAddress.complement = data.complement ? data.complement : "";
    this.dataAddress.district = data.district ? data.district : "";
    this.dataAddress.city = data.city ? data.city : "";
    this.dataAddress.state = data.state ? data.state : "";
    this.dataAddress.usuario_id = idUser;
    this.dataAddress.cep = data.cep ? data.cep : "";
    this.dataAddress.id = data.id ? data.id : "";
  },

  isValid() {
    if (!this.dataAddress.cep) {
      this.makeToast(
        'Erro',
        'O campo cep é obrigatório',
        'danger'
      );
      return false;
    } 
    if (!this.dataAddress.address){
      this.makeToast(
        'Erro',
        'O campo endereço é obrigatório',
        'danger'
      );
      return false;
    }
    if (!this.dataAddress.number){
      this.makeToast(
        'Erro',
        'O campo número é obrigatório',
        'danger'
      );
      return false;
    }
    if (!this.dataAddress.district){
      this.makeToast(
        'Erro',
        'O campo bairro é obrigatório',
        'danger'
      );
      return false;
    }
    if (!this.dataAddress.city){
      this.makeToast(
        'Erro',
        'O campo cidade é obrigatório',
        'danger'
      );
      return false;
    }
    if (!this.dataAddress.state){
      this.makeToast(
        'Erro',
        'O campo estado é obrigatório',
        'danger'
      );
      return false;
    }
    return true;
  },
  save() {
    if(!this.isValid()) return

    this.$store.dispatch('startLoader');
    this.loading = true;
    
    const createAddressAdditionalShopkeeper = this.$route.meta.userType  == UserTypes.BALCONISTA ?
      this.createAddressAdditionalByClerk(this.dataAddress) : 
      this.createAddressAdditional(this.dataAddress);

    createAddressAdditionalShopkeeper.then(() => {
        this.makeToast(
          'Sucesso',
          'Endereço cadastrado com sucesso',
          'success'
        );
        this.open = !this.open;
        this.$emit('getAddress')
      })
      .catch(() => {
        this.makeToast(
          'Erro',
          'Houve um erro ao salvar o endereço',
          'danger'
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
        this.loading = false;
      });
  },
  update() {
    if(!this.isValid()) return

    this.$store.dispatch('startLoader');
    this.loading = true;

    const updateAddressAdditionalShopkeeper = this.$route.meta.userType  == UserTypes.BALCONISTA ?
      this.updateAddressAdditionalByClerk(this.dataAddress) : 
      this.updateAddressAdditional(this.dataAddress);

    updateAddressAdditionalShopkeeper.then(() => {
        this.makeToast(
          'Sucesso',
          'Endereço atualizado com sucesso',
          'success'
        );
        this.open = !this.open;
        this.$emit('getAddress')
      })
      .catch(() => {
        this.makeToast(
          'Erro',
          'Houve um erro ao salvar o endereço',
          'danger'
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
        this.loading = false;
      });
    },

    consultCep() {
      if (!this.loading && this.dataAddress.cep.length === 9) {
        this.loading = true;
        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('user/consultCep', this.dataAddress.cep)
          .then(async (response) => {
            this.dataAddress.address = response.data.logradouro
            this.dataAddress.complement = response.data.complemento
            this.dataAddress.district = response.data.bairro
            this.dataAddress.city = response.data.localidade
            this.dataAddress.state = response.data.uf
          })
          .catch(() => {
            this.makeToast('Oopss!', 'E-mail já cadastrado!', 'danger');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch('endLoader');
          });
      }
    },
  },
};
</script>
<style></style>
